module.exports = __webpack_public_path__ + "img/winerackdog12.d93ca73c.jpg";